export interface MetaValueElementBackend {
  key: string;
  value?: string;
  aiValue?: string;
}

export interface MetaValueElementFrontend {
  metaKey: string;
  value?: string;
  aiValue?: string;
}

export const normalizeMetaKeyWords = (metaValuesArray: MetaValueElementBackend[]): MetaValueElementFrontend[] => {
    const result = metaValuesArray.map((metaValue) => {
        const { key, ...rest } = metaValue;

        return {
            metaKey: key,
            ...rest
        };
    });

    return result;
};
